export default __webpack_public_path__ + "static/media/main_theme.d553ca1b.mp3";